import React, { useCallback, useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { MonitoringContext } from '../monitoring.context';

import MonitoringContent from '../../../components/monitoringContent/monitoringContent';

import { actions } from '../../../state';

import styles from './panel.module.scss';

const PanelPage = ({ dispatch }) => {
  const { filteredBody, serviceId, setServiceId } = useContext(
    MonitoringContext
  );

  const clearMonitoring = useCallback(() => {
    dispatch(actions.monitoring.clearMonitoringAction());
  }, [dispatch]);

  const fetchMonitoringData = useCallback(data => {
    dispatch(actions.monitoring.getMonitoringAction(data));
  }, []);

  useEffect(() => () => clearMonitoring(), [clearMonitoring]);

  useEffect(() => {
    fetchMonitoringData(filteredBody);
  }, [fetchMonitoringData, filteredBody]);

  return (
    <div className={styles.monitoringPanel}>
      <MonitoringContent serviceId={serviceId} setServiceId={setServiceId} />
    </div>
  );
};

PanelPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default connect()(PanelPage);
